<template>
    <div class="banner-image-area position-relative">
        <div class="container_fl">
            <div class="row align-items-center banner-width">
                <div class="col-lg-1" v-if="!rightAlign"></div>

                <div class="col-lg-7 wow move-up" v-if="rightAlign">
                    <div class="banner-image__media">
                        <img :src="image" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-4 wow move-up" :class="{'flex justify-content-end' : !rightAlign}">
                    <div class="banner-image__content">
                        <div class="section-title-wrapper mb-20">
                            <h2 class="section-title font-weight--light"><slot name="header"></slot></h2>
                        </div>
                        <div class="banner-image__text section-space--mb_40"><slot name="main"></slot></div>
                        <h6 class="banner-image__helper-text">
                            <b-link :href="link" class="scroll hover-style-link hover-style-link--green">
                                {{ $t("knowledge.read_more") }}
                            </b-link>
                        </h6>
                    </div>
                </div>
                <div class="col-lg-7 wow move-up" v-if="!rightAlign">
                    <div class="banner-image__media">
                        <img :src="image" class="img-fluid" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContentBanner',
    props: {
        link: {
            type: String
        },
        image: {
            type: String
        },
        rightAlign: {
            type: Boolean,
            default: false
        }
    }
};
</script>
